import React from "react";

export default () => (
  <div className="loader-container">
    <div className="fa-2x loader">
      <i className="fas fa-spinner fa-pulse"></i>
    </div>
  </div>
);
